import { Clip, Instrument, Mode, VocalStyle } from "./models";

export const clips: Clip[] = [
  {
    "density": 5,
    "duration": 274.68,
    "filename": "/clips/nsrmntbl01.mp3",
    "trackVersion": "1",
    "gdrive": "https://drive.google.com/uc?id=1RQcxV40s3SggtXtus9c-cF4n06goatnM",
    "order": 46,
    "group": "E",
    "id": 1,
    "intensity": 4,
    "instrumentation": [Instrument.ElGuitarPerc, Instrument.Rhodes],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "F",
    "lyrics": "insurmountable1",
    "poolName": "MOTH",
    "trackName": "Insurmountable",
    "trackNameVersion": "Unsuitable Norm",
    "vocal": VocalStyle.Multi
  },
  {
    "density": 3,
    "duration": 245.9,
    "filename": "/clips/nsrmntbl02.mp3",
    "trackVersion": "2",
    "gdrive": "https://drive.google.com/uc?id=1dBVu272Dti635WrVnrhNoneHHpPRZZSU",
    "order": 47,
    "group": "E",
    "id": 2,
    "intensity": 3,
    "instrumentation": [Instrument.ElGuitarPerc, Instrument.Rhodes],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "F",
    "lyrics": "insurmountable1",
    "poolName": "MOTH",
    "trackName": "Insurmountable",
    "trackNameVersion": "Mountable Ruins",
    "vocal": VocalStyle.Multi
  },
  {
    "density": 3,
    "duration": 245.9,
    "filename": "/clips/nsrmntbl03.mp3",
    "trackVersion": "3",
    "gdrive": "https://drive.google.com/uc?id=12L_PVVK_csz9SQ1HZQFkzI1c2A0LFsmN",
    "order": 48,
    "group": "E",
    "id": 3,
    "intensity": 3,
    "instrumentation": [Instrument.ElGuitarPerc, Instrument.Rhodes],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "F",
    "lyrics": "insurmountable2",
    "poolName": "MOTH",
    "trackName": "Insurmountable",
    "trackNameVersion": "Turban Emulsion",
    "vocal": VocalStyle.Speak
  },
  {
    "density": 4,
    "duration": 230.62,
    "filename": "/clips/nsrmntbl04.mp3",
    "trackVersion": "4",
    "gdrive": "https://drive.google.com/uc?id=1veOmZi4Z7Ore4aEwr9S1oyDS1CinnqEO",
    "order": 49,
    "group": "E",
    "id": 4,
    "intensity": 2,
    "instrumentation": [Instrument.ElGuitarBow, Instrument.Organ],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "F",
    "lyrics": "insurmountable2",
    "poolName": "MOTH",
    "trackName": "Insurmountable",
    "trackNameVersion": "Menial Burnouts",
    "vocal": VocalStyle.Sing
  },
  {
    "density": 5,
    "duration": 230.62,
    "filename": "/clips/nsrmntbl05.mp3",
    "trackVersion": "5",
    "gdrive": "https://drive.google.com/uc?id=1lN1a_ULqNV8Qo1AXRW9vQHdhF1xOAlEb",
    "order": 50,
    "group": "E",
    "id": 5,
    "intensity": 2,
    "instrumentation": [Instrument.ElGuitarBow, Instrument.Organ],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "F",
    "lyrics": "insurmountable1",
    "poolName": "MOTH",
    "trackName": "Insurmountable",
    "trackNameVersion": "Simulate Unborn",
    "vocal": VocalStyle.Growl
  },
  {
    "density": 3,
    "duration": 244.75,
    "filename": "/clips/nsrmntbl06.mp3",
    "trackVersion": "6",
    "gdrive": "https://drive.google.com/uc?id=1Dnpxx4JI3x5F2eE-u-p5kxToCwMRCsto",
    "order": 51,
    "group": "E",
    "id": 6,
    "intensity": 2,
    "instrumentation": [Instrument.Rhodes, Instrument.Kalimba],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "F",
    "lyrics": "insurmountable2",
    "poolName": "MOTH",
    "trackName": "Insurmountable",
    "trackNameVersion": "Ruminant Blouse",
    "vocal": VocalStyle.Speak
  },
  {
    "density": 3,
    "duration": 244.75,
    "filename": "/clips/nsrmntbl07.mp3",
    "trackVersion": "7",
    "gdrive": "https://drive.google.com/uc?id=12lVQZs_NAldfWlUcX32YHO6rw3atZGYA",
    "order": 52,
    "group": "E",
    "id": 7,
    "intensity": 2,
    "instrumentation": [Instrument.Rhodes, Instrument.Kalimba],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "F",
    "lyrics": "insurmountable1",
    "poolName": "MOTH",
    "trackName": "Insurmountable",
    "trackNameVersion": "Ambient Soul Urn",
    "vocal": VocalStyle.Speak
  },
  {
    "density": 3,
    "duration": 231.48,
    "filename": "/clips/nsrmntbl08.mp3",
    "trackVersion": "8",
    "gdrive": "https://drive.google.com/uc?id=1ebYt8ULPB-rsGefMA_ok4-KgZRjdYX_H",
    "order": 53,
    "group": "E",
    "id": 8,
    "intensity": 2,
    "instrumentation": [Instrument.ElGuitar, Instrument.Mandolin, Instrument.Drums],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "F",
    "lyrics": "insurmountable2",
    "poolName": "MOTH",
    "trackName": "Insurmountable",
    "trackNameVersion": "Luminous Banter",
    "vocal": VocalStyle.Sing
  },
  {
    "density": 3,
    "duration": 231.48,
    "filename": "/clips/nsrmntbl09.mp3",
    "trackVersion": "9",
    "gdrive": "https://drive.google.com/uc?id=1Q2qZqW3yV6CKCV0OrB8SrplsTkcslQOY",
    "order": 54,
    "group": "E",
    "id": 9,
    "intensity": 2,
    "instrumentation": [Instrument.ElGuitar, Instrument.Mandolin, Instrument.Drums],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "F",
    "lyrics": "insurmountable1",
    "poolName": "MOTH",
    "trackName": "Insurmountable",
    "trackNameVersion": "Tourmaline Buns",
    "vocal": VocalStyle.Speak
  },
  {
    "density": 3,
    "duration": 329.5,
    "filename": "/clips/themoth01.mp3",
    "trackVersion": "1",
    "gdrive": "https://drive.google.com/uc?id=17hKoP0wUEvY_qWdE67O6VaPYeimhIvM6",
    "order": 66,
    "group": "G",
    "id": 10,
    "intensity": 2,
    "instrumentation": [Instrument.ElGuitar, Instrument.Rhodes, Instrument.AcousticEffects],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "C#",
    "lyrics": "",
    "poolName": "MOTH",
    "trackName": "The Moth",
    "trackNameVersion": "Them Tho",
    "vocal": VocalStyle.Sing
  },
  {
    "density": 3,
    "duration": 338.18,
    "filename": "/clips/themoth02.mp3",
    "trackVersion": "2",
    "gdrive": "https://drive.google.com/uc?id=1AYPtmoJXTCYvL88KGXm6effKkXytoF44",
    "order": 67,
    "group": "G",
    "id": 11,
    "intensity": 2,
    "instrumentation": [Instrument.Rhodes, Instrument.Glasses],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "C#",
    "lyrics": "",
    "poolName": "MOTH",
    "trackName": "The Moth",
    "trackNameVersion": "Me, Thoth",
    "vocal": VocalStyle.Sing
  },
  {
    "density": 5,
    "duration": 84.72,
    "filename": "/clips/themoth03.mp3",
    "trackVersion": "3",
    "gdrive": "https://drive.google.com/uc?id=1UYuIYVF7OF93mXTiLoEP81FmJKycQgoe",
    "order": 68,
    "group": "G",
    "id": 12,
    "intensity": 5,
    "instrumentation": [Instrument.Noise],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "C#",
    "lyrics": "theroots",
    "poolName": "MOTH",
    "trackName": "The Moth",
    "trackNameVersion": "Het Thom",
    "vocal": VocalStyle.Speak
  },
  {
    "density": 5,
    "duration": 93.17,
    "filename": "/clips/themoth04.mp3",
    "trackVersion": "4",
    "gdrive": "https://drive.google.com/uc?id=1nIkPOh1k8JXzJ_Y-K882ZAmrECsvROPU",
    "order": 69,
    "group": "G",
    "id": 13,
    "intensity": 5,
    "instrumentation": [Instrument.Noise],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "C#",
    "lyrics": "asign",
    "poolName": "MOTH",
    "trackName": "The Moth",
    "trackNameVersion": "Hot Them",
    "vocal": VocalStyle.Whisper
  },
  {
    "density": 5,
    "duration": 99.12,
    "filename": "/clips/themoth05.mp3",
    "trackVersion": "5",
    "gdrive": "https://drive.google.com/uc?id=1e8dKUGTEk3Bl41QKw3PAprHgmANOb4KS",
    "order": 70,
    "group": "G",
    "id": 14,
    "intensity": 5,
    "instrumentation": [Instrument.Noise],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "C#",
    "lyrics": "thefold",
    "poolName": "MOTH",
    "trackName": "The Moth",
    "trackNameVersion": "Ethmoth",
    "vocal": VocalStyle.Whisper
  },
  {
    "density": 3,
    "duration": 179.16,
    "filename": "/clips/blackpencil01.mp3",
    "trackVersion": "1",
    "gdrive": "https://drive.google.com/uc?id=1xFQiAj4eak3w1ptkdK1LOxcK2FfJ7LtU",
    "order": 55,
    "group": "F",
    "id": 15,
    "intensity": 4,
    "instrumentation": [Instrument.Rhodes, Instrument.Digitone, Instrument.AcousticPercussion],
    "rootMode": Mode.Byzantine,
    "rootTone": "Bb",
    "lyrics": "blackpencil1",
    "poolName": "PNCL",
    "trackName": "Black Pencil Draws",
    "trackNameVersion": "Blind Wreck Pascal",
    "vocal": VocalStyle.Whisper
  },
  {
    "density": 3,
    "duration": 179.16,
    "filename": "/clips/blackpencil02.mp3",
    "trackVersion": "2",
    "gdrive": "https://drive.google.com/uc?id=1-6Xz72ueHBzkwqF1ZlLoUMj7pnrRNmQF",
    "order": 56,
    "group": "F",
    "id": 16,
    "intensity": 4,
    "instrumentation": [Instrument.Rhodes, Instrument.Digitone, Instrument.AcousticPercussion],
    "rootMode": Mode.Byzantine,
    "rootTone": "Bb",
    "lyrics": "blackpencil2",
    "poolName": "PNCL",
    "trackName": "Black Pencil Draws",
    "trackNameVersion": "Crab Packs Indwell",
    "vocal": VocalStyle.Growl
  },
  {
    "density": 3,
    "duration": 188.16,
    "filename": "/clips/blackpencil03.mp3",
    "trackVersion": "3",
    "gdrive": "https://drive.google.com/uc?id=1YXJ9O4OYagWCySDZLfutXb7KSKLaJBkL",
    "order": 57,
    "group": "F",
    "id": 17,
    "intensity": 4,
    "instrumentation": [Instrument.Rhodes, Instrument.Digitone, Instrument.AcousticPercussion],
    "rootMode": Mode.Byzantine,
    "rootTone": "Bb",
    "lyrics": "",
    "poolName": "PNCL",
    "trackName": "Black Pencil Draws",
    "trackNameVersion": "Blade Prawns Click",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 3,
    "duration": 260.47,
    "filename": "/clips/blackpencil04.mp3",
    "trackVersion": "4",
    "gdrive": "https://drive.google.com/uc?id=1Fe4aXYw3wzhFQc6afsOE07hsBDlEsGrG",
    "order": 58,
    "group": "F",
    "id": 18,
    "intensity": 3,
    "instrumentation": [Instrument.ElGuitar, Instrument.Digitone, Instrument.AcousticPercussion],
    "rootMode": Mode.Byzantine,
    "rootTone": "Bb",
    "lyrics": "blackpencil1",
    "poolName": "PNCL",
    "trackName": "Black Pencil Draws",
    "trackNameVersion": "Crisp Blacked Lawn",
    "vocal": VocalStyle.Whisper
  },
  {
    "density": 3,
    "duration": 260.47,
    "filename": "/clips/blackpencil05.mp3",
    "trackVersion": "5",
    "gdrive": "https://drive.google.com/uc?id=1WSNPSmHo-ahd8GfrbtqlFDQsAy2jJgom",
    "order": 59,
    "group": "F",
    "id": 19,
    "intensity": 3,
    "instrumentation": [Instrument.ElGuitar, Instrument.Digitone, Instrument.AcousticPercussion],
    "rootMode": Mode.Byzantine,
    "rootTone": "Bb",
    "lyrics": "blackpencil2",
    "poolName": "PNCL",
    "trackName": "Black Pencil Draws",
    "trackNameVersion": "Backslid Crew Plan",
    "vocal": VocalStyle.Multi
  },
  {
    "density": 4,
    "duration": 181.2,
    "filename": "/clips/blackpencil06.mp3",
    "trackVersion": "6",
    "gdrive": "https://drive.google.com/uc?id=1Fs5ZH6E0FoJnqR1os7iwfyr6EnALgPHd",
    "order": 60,
    "group": "F",
    "id": 20,
    "intensity": 4,
    "instrumentation": [Instrument.ElGuitar, Instrument.Digitone, Instrument.AcousticPercussion],
    "rootMode": Mode.Byzantine,
    "rootTone": "Bb",
    "lyrics": "",
    "poolName": "PNCL",
    "trackName": "Black Pencil Draws",
    "trackNameVersion": "Warbled Scalp Nick",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 4,
    "duration": 209.21,
    "filename": "/clips/blackpencil07.mp3",
    "trackVersion": "7",
    "gdrive": "https://drive.google.com/uc?id=1PG9cZHm19vZM3hmJPaRoEFGvgFb_XqJw",
    "order": 61,
    "group": "F",
    "id": 21,
    "intensity": 3,
    "instrumentation": [Instrument.ElGuitar, Instrument.Digitone],
    "rootMode": Mode.Byzantine,
    "rootTone": "Bb",
    "lyrics": "blackpencil1",
    "poolName": "PNCL",
    "trackName": "Black Pencil Draws",
    "trackNameVersion": "Pawned Brick Calls",
    "vocal": VocalStyle.Growl
  },
  {
    "density": 4,
    "duration": 209.21,
    "filename": "/clips/blackpencil08.mp3",
    "trackVersion": "8",
    "gdrive": "https://drive.google.com/uc?id=1MCwPbkdViMVxo9E_0cidKtZ_TM_Qw1pl",
    "order": 62,
    "group": "F",
    "id": 22,
    "intensity": 3,
    "instrumentation": [Instrument.ElGuitar, Instrument.Digitone],
    "rootMode": Mode.Byzantine,
    "rootTone": "Bb",
    "lyrics": "blackpencil2",
    "poolName": "PNCL",
    "trackName": "Black Pencil Draws",
    "trackNameVersion": "Crack Spawn Billed",
    "vocal": VocalStyle.Growl
  },
  {
    "density": 4,
    "duration": 209.21,
    "filename": "/clips/blackpencil09.mp3",
    "trackVersion": "9",
    "gdrive": "https://drive.google.com/uc?id=180J5uVV4DA1tLi23CpVsHKwSiiE1vW7w",
    "order": 63,
    "group": "F",
    "id": 23,
    "intensity": 3,
    "instrumentation": [Instrument.ElGuitar, Instrument.Digitone],
    "rootMode": Mode.Byzantine,
    "rootTone": "Bb",
    "lyrics": "",
    "poolName": "PNCL",
    "trackName": "Black Pencil Draws",
    "trackNameVersion": "Backward Spin Cell",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 2,
    "duration": 209.62,
    "filename": "/clips/innerworkings01.mp3",
    "trackVersion": "1",
    "gdrive": "https://drive.google.com/uc?id=1rgTkdO6vMK2z0is5whOzZ5m2rf6LqCAr",
    "order": 29,
    "group": "C",
    "id": 24,
    "intensity": 2,
    "instrumentation": [Instrument.ElGuitar, Instrument.AcousticPercussion],
    "rootMode": Mode.Phrygian,
    "rootTone": "C",
    "lyrics": "innerworkings",
    "poolName": "PNCL",
    "trackName": "Inner Workings",
    "trackNameVersion": "Reworking Inns",
    "vocal": VocalStyle.Speak
  },
  {
    "density": 2,
    "duration": 209.62,
    "filename": "/clips/innerworkings02.mp3",
    "trackVersion": "2",
    "gdrive": "https://drive.google.com/uc?id=1t_pYQfFhWzK6vjzhW0glRCZiF1UlXgQ6",
    "order": 30,
    "group": "D",
    "id": 25,
    "intensity": 2,
    "instrumentation": [Instrument.ElGuitar, Instrument.AcousticPercussion],
    "rootMode": Mode.Phrygian,
    "rootTone": "C",
    "lyrics": "innerworkings",
    "poolName": "PNCL",
    "trackName": "Inner Workings",
    "trackNameVersion": "Worsening Rink",
    "vocal": VocalStyle.Sing
  },
  {
    "density": 2,
    "duration": 166.99,
    "filename": "/clips/innerworkings03.mp3",
    "trackVersion": "3",
    "gdrive": "https://drive.google.com/uc?id=1e0zrLHsERMNKMqImkrV-YuuHJ__JxRPa",
    "order": 31,
    "group": "C",
    "id": 26,
    "intensity": 2,
    "instrumentation": [Instrument.Bass, Instrument.Kalimba],
    "rootMode": Mode.Phrygian,
    "rootTone": "C",
    "lyrics": "innerworkings",
    "poolName": "PNCL",
    "trackName": "Inner Workings",
    "trackNameVersion": "Snorer Winking",
    "vocal": VocalStyle.Speak
  },
  {
    "density": 2,
    "duration": 166.99,
    "filename": "/clips/innerworkings04.mp3",
    "trackVersion": "4",
    "gdrive": "https://drive.google.com/uc?id=1tYBKoFlnriD721td1tqdAAHT9pQ4OBgb",
    "order": 32,
    "group": "C",
    "id": 27,
    "intensity": 2,
    "instrumentation": [Instrument.Bass, Instrument.Kalimba],
    "rootMode": Mode.Phrygian,
    "rootTone": "C",
    "lyrics": "riteofpassage",
    "poolName": "PNCL",
    "trackName": "Inner Workings",
    "trackNameVersion": "Winker Snoring",
    "vocal": VocalStyle.Speak
  },
  {
    "density": 2,
    "duration": 238.46,
    "filename": "/clips/innerworkings05.mp3",
    "trackVersion": "5",
    "gdrive": "https://drive.google.com/uc?id=1CIETb65rfl_OFzg0CwPutCAR9gtSUCvf",
    "order": 33,
    "group": "C",
    "id": 28,
    "intensity": 2,
    "instrumentation": [Instrument.Rhodes],
    "rootMode": Mode.Phrygian,
    "rootTone": "C",
    "lyrics": "innerworkings",
    "poolName": "PNCL",
    "trackName": "Inner Workings",
    "trackNameVersion": "Rower Skinning",
    "vocal": VocalStyle.Speak
  },
  {
    "density": 2,
    "duration": 215.14,
    "filename": "/clips/innerworkings06.mp3",
    "trackVersion": "6",
    "gdrive": "https://drive.google.com/uc?id=1zs6egPmWMrEir1ASngXd4wGmwz4-n1Qi",
    "order": 34,
    "group": "C",
    "id": 29,
    "intensity": 2,
    "instrumentation": [Instrument.Rhodes, Instrument.AcousticPercussion],
    "rootMode": Mode.Phrygian,
    "rootTone": "C",
    "lyrics": "",
    "poolName": "PNCL",
    "trackName": "Inner Workings",
    "trackNameVersion": "Sinner Working",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 2,
    "duration": 213.43,
    "filename": "/clips/innerworkings07.mp3",
    "trackVersion": "7",
    "gdrive": "https://drive.google.com/uc?id=17_GkXlX9msp2hIoI2ZPLBkCyWTfs5fnJ",
    "order": 35,
    "group": "C",
    "id": 30,
    "intensity": 2,
    "instrumentation": [Instrument.Rhodes, Instrument.AcousticPercussion],
    "rootMode": Mode.Phrygian,
    "rootTone": "C",
    "lyrics": "riteofpassage",
    "poolName": "PNCL",
    "trackName": "Inner Workings",
    "trackNameVersion": "Renown Risking",
    "vocal": VocalStyle.Speak
  },
  {
    "density": 3,
    "duration": 258.62,
    "filename": "/clips/trajectories01.mp3",
    "trackVersion": "1",
    "gdrive": "https://drive.google.com/uc?id=1AzsbW5Ud-9E9FUge1M6J-NhCvUdmr2Ym",
    "order": 41,
    "group": "C",
    "id": 31,
    "intensity": 3,
    "instrumentation": [Instrument.ElGuitar, Instrument.Drums],
    "rootMode": Mode.Phrygian,
    "rootTone": "Eb",
    "lyrics": "stonepeople123",
    "poolName": "PNCL",
    "trackName": "Unfamiliar Trajectories / Stroke of Luck",
    "trackNameDisplay": "Unfamiliar Trajectories",
    "trackNameVersion": "Inarticulate Major Fires",
    "vocal": VocalStyle.Whisper
  },
  {
    "density": 2,
    "duration": 218.95,
    "filename": "/clips/trajectories02.mp3",
    "trackVersion": "2",
    "gdrive": "https://drive.google.com/uc?id=1fTuDub5ys02JUqCR7ySpdxl_Id9jcoXR",
    "order": 42,
    "group": "C",
    "id": 32,
    "intensity": 3,
    "instrumentation": [Instrument.ElGuitar, Instrument.Drums],
    "rootMode": Mode.PentatonicMinor,
    "rootTone": "Eb",
    "lyrics": "stonepeople123",
    "poolName": "PNCL",
    "trackName": "Unfamiliar Trajectories / Stroke of Luck",
    "trackNameDisplay": "Unfamiliar Trajectories",
    "trackNameVersion": "Artificial Jaunt Remorse",
    "vocal": VocalStyle.Whisper
  },
  {
    "density": 4,
    "duration": 160.34,
    "filename": "/clips/strokeofluck01.mp3",
    "trackVersion": "1",
    "gdrive": "https://drive.google.com/uc?id=16XcDk-4UddrCUq3aYUlZclN2KB4KP9V9",
    "order": 38,
    "group": "D",
    "id": 33,
    "intensity": 4,
    "instrumentation": [Instrument.Rhodes, Instrument.Harmonica],
    "rootMode": Mode.Dissonant,
    "rootTone": "C",
    "lyrics": "stonepeople1",
    "poolName": "PNCL",
    "trackName": "Unfamiliar Trajectories / Stroke of Luck",
    "trackNameDisplay": "Stroke of Luck",
    "trackNameVersion": "Rocket of Sulk",
    "vocal": VocalStyle.Growl
  },
  {
    "density": 4,
    "duration": 160.34,
    "filename": "/clips/strokeofluck02.mp3",
    "trackVersion": "2",
    "gdrive": "https://drive.google.com/uc?id=1XwvqyZ3ipJ3SS2gYxdtGbeoaL5lUfIIV",
    "order": 39,
    "group": "D",
    "id": 34,
    "intensity": 4,
    "instrumentation": [Instrument.Rhodes, Instrument.Harmonica],
    "rootMode": Mode.Dissonant,
    "rootTone": "C",
    "lyrics": "stonepeople2",
    "poolName": "PNCL",
    "trackName": "Unfamiliar Trajectories / Stroke of Luck",
    "trackNameDisplay": "Stroke of Luck",
    "trackNameVersion": "Stuck Elf Rook",
    "vocal": VocalStyle.Growl
  },
  {
    "density": 4,
    "duration": 160.34,
    "filename": "/clips/strokeofluck03.mp3",
    "trackVersion": "3",
    "gdrive": "https://drive.google.com/uc?id=1E4dnOr5mPsowRrbGdIOGZZZW2-8N2cOd",
    "order": 40,
    "group": "D",
    "id": 35,
    "intensity": 4,
    "instrumentation": [Instrument.Rhodes, Instrument.Harmonica],
    "rootMode": Mode.Dissonant,
    "rootTone": "C",
    "lyrics": "stonepeople3",
    "poolName": "PNCL",
    "trackName": "Unfamiliar Trajectories / Stroke of Luck",
    "trackNameDisplay": "Stroke of Luck",
    "trackNameVersion": "Tusk Core Folk",
    "vocal": VocalStyle.Growl
  },
  {
    "density": 5,
    "duration": 222,
    "filename": "/clips/snowwhitepriests01.mp3",
    "trackVersion": "1",
    "gdrive": "https://drive.google.com/uc?id=1q7UJptAOwA5RCrTK-_h44QtO8CqRxCe0",
    "order": 64,
    "group": "G",
    "id": 36,
    "intensity": 5,
    "instrumentation": [Instrument.Mandolin, Instrument.Bass, Instrument.Drums],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "F",
    "lyrics": "snowwhitepriests",
    "poolName": "MOTH",
    "trackName": "Snow White Priests",
    "trackNameVersion": "Sir Whetstone Wisp",
    "vocal": VocalStyle.Speak
  },
  {
    "density": 5,
    "duration": 222,
    "filename": "/clips/snowwhitepriests02.mp3",
    "trackVersion": "2",
    "gdrive": "https://drive.google.com/uc?id=1Xikylud1ro8TtQYlyTkHxpm0tEpf-lQp",
    "order": 65,
    "group": "G",
    "id": 37,
    "intensity": 5,
    "instrumentation": [Instrument.Mandolin, Instrument.Bass, Instrument.Drums],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "F",
    "lyrics": "snowwhitepriests",
    "poolName": "MOTH",
    "trackName": "Snow White Priests",
    "trackNameVersion": "Sweetish Snow Trip",
    "vocal": VocalStyle.Whisper
  },
  {
    "density": 3,
    "duration": 253.22,
    "filename": "/clips/snowwhitepriests03.mp3",
    "trackVersion": "3",
    "gdrive": "https://drive.google.com/uc?id=1POqdOd9DAjqV5Pdr8hwcJwRiKrm_Uxno",
    "order": 36,
    "group": "D",
    "id": 38,
    "intensity": 4,
    "instrumentation": [Instrument.Rhodes, Instrument.Harmonica],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "F",
    "lyrics": "snowwhitepriests",
    "poolName": "MOTH",
    "trackName": "Snow White Priests",
    "trackNameVersion": "Nitwit Sows Sphere",
    "vocal": VocalStyle.Whisper
  },
  {
    "density": 3,
    "duration": 253.22,
    "filename": "/clips/snowwhitepriests04.mp3",
    "trackVersion": "4",
    "gdrive": "https://drive.google.com/uc?id=1wTDzeXEm6eIcK7PNdcW8CgKnYbUiL0ZN",
    "order": 37,
    "group": "D",
    "id": 39,
    "intensity": 4,
    "instrumentation": [Instrument.Rhodes, Instrument.Harmonica],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "F",
    "lyrics": "snowwhitepriests",
    "poolName": "MOTH",
    "trackName": "Snow White Priests",
    "trackNameVersion": "Whiteness Rips Two",
    "vocal": VocalStyle.Speak
  },
  {
    "density": 1,
    "duration": 209.64,
    "filename": "/clips/snowwhitepriests05.mp3",
    "trackVersion": "5",
    "gdrive": "https://drive.google.com/uc?id=1428FbsFoZLufFaMU4eeaKqAUCu-9aFZh",
    "order": 1,
    "group": "A",
    "id": 40,
    "intensity": 1,
    "instrumentation": [Instrument.Rhodes, Instrument.Harmonica],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "F",
    "lyrics": "snowwhitepriests",
    "poolName": "MOTH",
    "trackName": "Snow White Priests",
    "trackNameVersion": "Twenties Worships",
    "vocal": VocalStyle.Growl
  },
  {
    "density": 1,
    "duration": 209.64,
    "filename": "/clips/snowwhitepriests06.mp3",
    "trackVersion": "6",
    "gdrive": "https://drive.google.com/uc?id=1--6yU8gp1koS45wHOYa_ULhY0cEsa-xK",
    "order": 2,
    "group": "A",
    "id": 41,
    "intensity": 1,
    "instrumentation": [Instrument.Rhodes, Instrument.Harmonica],
    "rootMode": Mode.HarmonicMinor,
    "rootTone": "F",
    "lyrics": "snowwhitepriests",
    "poolName": "MOTH",
    "trackName": "Snow White Priests",
    "trackNameVersion": "Newsworthiest Sip",
    "vocal": VocalStyle.Speak
  },
  {
    "density": 2,
    "duration": 257.59,
    "filename": "/clips/moonvortex01.mp3",
    "trackVersion": "1",
    "gdrive": "https://drive.google.com/uc?id=1cEyGAn9BN_yzGQS5usyj1xr4DK-Ic-6K",
    "order": 9,
    "group": "B",
    "id": 42,
    "intensity": 1,
    "instrumentation": [Instrument.ElGuitar],
    "rootMode": Mode.Major,
    "rootTone": "Bb",
    "lyrics": "",
    "poolName": "VRTX",
    "trackName": "Moon Vortex",
    "trackNameVersion": "Venom Tor Ox",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 2,
    "duration": 257.59,
    "filename": "/clips/moonvortex02.mp3",
    "trackVersion": "2",
    "gdrive": "https://drive.google.com/uc?id=1UFuXk86_c8pLHdNDgH1RA_CIQ_mzgdoX",
    "order": 10,
    "group": "B",
    "id": 43,
    "intensity": 1,
    "instrumentation": [Instrument.ElGuitar],
    "rootMode": Mode.Major,
    "rootTone": "Bb",
    "lyrics": "",
    "poolName": "VRTX",
    "trackName": "Moon Vortex",
    "trackNameVersion": "Ox, Not Mover",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 2,
    "duration": 257.59,
    "filename": "/clips/moonvortex03.mp3",
    "trackVersion": "3",
    "gdrive": "https://drive.google.com/uc?id=1pd-mw4zcKgcgkZfQRTxD686-u8Lnb381",
    "order": 11,
    "group": "B",
    "id": 44,
    "intensity": 1,
    "instrumentation": [Instrument.ElGuitar],
    "rootMode": Mode.Major,
    "rootTone": "Bb",
    "lyrics": "",
    "poolName": "VRTX",
    "trackName": "Moon Vortex",
    "trackNameVersion": "Vent Room Ox",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 2,
    "duration": 254.21,
    "filename": "/clips/moonvortex04.mp3",
    "trackVersion": "4",
    "gdrive": "https://drive.google.com/uc?id=1f5tMqAfNXwsk0qEwpVt82Cc8_kcMSoAx",
    "order": 12,
    "group": "B",
    "id": 45,
    "intensity": 1,
    "instrumentation": [Instrument.Organ, Instrument.Kalimba],
    "rootMode": Mode.Major,
    "rootTone": "Bb",
    "lyrics": "",
    "poolName": "VRTX",
    "trackName": "Moon Vortex",
    "trackNameVersion": "Oxen Room TV",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 2,
    "duration": 254.21,
    "filename": "/clips/moonvortex05.mp3",
    "trackVersion": "5",
    "gdrive": "https://drive.google.com/uc?id=1AqE2W84E8Rz0RQ4jxdAvs_Nvd0rMChcL",
    "order": 13,
    "group": "B",
    "id": 46,
    "intensity": 1,
    "instrumentation": [Instrument.Organ, Instrument.Kalimba],
    "rootMode": Mode.Major,
    "rootTone": "Bb",
    "lyrics": "",
    "poolName": "VRTX",
    "trackName": "Moon Vortex",
    "trackNameVersion": "Veto Norm Ox",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 2,
    "duration": 254.21,
    "filename": "/clips/moonvortex06.mp3",
    "trackVersion": "6",
    "gdrive": "https://drive.google.com/uc?id=1SrWq6Hz3SzZqqROtFEACP1McwqFtLPeP",
    "order": 14,
    "group": "B",
    "id": 47,
    "intensity": 1,
    "instrumentation": [Instrument.Organ, Instrument.Kalimba],
    "rootMode": Mode.Major,
    "rootTone": "Bb",
    "lyrics": "",
    "poolName": "VRTX",
    "trackName": "Moon Vortex",
    "trackNameVersion": "Moron Vet Ox",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 2,
    "duration": 251.9,
    "filename": "/clips/moonvortex07.mp3",
    "trackVersion": "7",
    "gdrive": "https://drive.google.com/uc?id=1qHy805OACOlYrH-wGu6Adr4eOjeVJ93N",
    "order": 15,
    "group": "B",
    "id": 48,
    "intensity": 1,
    "instrumentation": [Instrument.Rhodes],
    "rootMode": Mode.Major,
    "rootTone": "Bb",
    "lyrics": "",
    "poolName": "VRTX",
    "trackName": "Moon Vortex",
    "trackNameVersion": "Eon Vox Mort",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 2,
    "duration": 251.9,
    "filename": "/clips/moonvortex08.mp3",
    "trackVersion": "8",
    "gdrive": "https://drive.google.com/uc?id=1sk6jry63hXKTTAGcCQWnNAydOm2cL9nV",
    "order": 16,
    "group": "B",
    "id": 49,
    "intensity": 1,
    "instrumentation": [Instrument.Rhodes],
    "rootMode": Mode.Major,
    "rootTone": "Bb",
    "lyrics": "",
    "poolName": "VRTX",
    "trackName": "Moon Vortex",
    "trackNameVersion": "Ex von Motor",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 2,
    "duration": 251.9,
    "filename": "/clips/moonvortex09.mp3",
    "trackVersion": "9",
    "gdrive": "https://drive.google.com/uc?id=1EdOtwQMJLOHJWx555m3KflcMVL83UcbD",
    "order": 17,
    "group": "B",
    "id": 50,
    "intensity": 1,
    "instrumentation": [Instrument.Rhodes],
    "rootMode": Mode.Major,
    "rootTone": "Bb",
    "lyrics": "",
    "poolName": "VRTX",
    "trackName": "Moon Vortex",
    "trackNameVersion": "Omen Root XV",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 3,
    "duration": 291.05,
    "filename": "/clips/neons01.mp3",
    "trackVersion": "1",
    "gdrive": "https://drive.google.com/uc?id=1uZNizHBx4nFWPyNodYi5Nw6fhjbZds6o",
    "order": 18,
    "group": "B",
    "id": 51,
    "intensity": 1,
    "instrumentation": [Instrument.Harmonium, Instrument.AcousticEffects],
    "rootMode": Mode.Major,
    "rootTone": "A",
    "lyrics": "",
    "poolName": "VRTX",
    "trackName": "The Neons",
    "trackNameVersion": "Not Sheen",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 2,
    "duration": 291.05,
    "filename": "/clips/neons02.mp3",
    "trackVersion": "2",
    "gdrive": "https://drive.google.com/uc?id=1RAzFcB8SmV_8Qtu8R5JbLw4QaMLqqb5e",
    "order": 19,
    "group": "B",
    "id": 52,
    "intensity": 1,
    "instrumentation": [Instrument.Harmonium, Instrument.AcousticEffects],
    "rootMode": Mode.Major,
    "rootTone": "A",
    "lyrics": "",
    "poolName": "VRTX",
    "trackName": "The Neons",
    "trackNameVersion": "Tense Hon",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 2,
    "duration": 352.61,
    "filename": "/clips/neons03.mp3",
    "trackVersion": "3",
    "gdrive": "https://drive.google.com/uc?id=1oQurO1Azg7pIwNh1OLAHQLHep-nndlgU",
    "order": 20,
    "group": "B",
    "id": 53,
    "intensity": 1,
    "instrumentation": [Instrument.Digitone, Instrument.ElGuitar],
    "rootMode": Mode.Major,
    "rootTone": "F",
    "lyrics": "",
    "poolName": "VRTX",
    "trackName": "The Neons",
    "trackNameVersion": "Sonnet Eh",
    "vocal": VocalStyle.Sing
  },
  {
    "density": 2,
    "duration": 352.61,
    "filename": "/clips/neons04.mp3",
    "trackVersion": "4",
    "gdrive": "https://drive.google.com/uc?id=1OMw2nC1uugV933RPJpilePjPMfMh2lM_",
    "order": 21,
    "group": "B",
    "id": 54,
    "intensity": 1,
    "instrumentation": [Instrument.Digitone, Instrument.ElGuitar],
    "rootMode": Mode.Major,
    "rootTone": "F",
    "lyrics": "",
    "poolName": "VRTX",
    "trackName": "The Neons",
    "trackNameVersion": "Hen Stone",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 2,
    "duration": 325.15,
    "filename": "/clips/neons05.mp3",
    "trackVersion": "5",
    "gdrive": "https://drive.google.com/uc?id=1UfAgek8NPBUDB3nL9TZbR1bg8OpVBCgj",
    "order": 22,
    "group": "B",
    "id": 55,
    "intensity": 1,
    "instrumentation": [Instrument.Rhodes, Instrument.AcousticEffects],
    "rootMode": Mode.MinorMajor,
    "rootTone": "A",
    "lyrics": "",
    "poolName": "VRTX",
    "trackName": "The Neons",
    "trackNameVersion": "Teen Nosh",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 2,
    "duration": 155.83,
    "filename": "/clips/fieldofgrass01.mp3",
    "trackVersion": "1",
    "gdrive": "https://drive.google.com/uc?id=17-b-7WJwTRdADjidV8BPMy_Kf0yp9LIa",
    "order": 23,
    "group": "B",
    "id": 56,
    "intensity": 2,
    "instrumentation": [Instrument.Rhodes, Instrument.AcousticEffects],
    "rootMode": Mode.PentatonicMajor,
    "rootTone": "F",
    "lyrics": "",
    "poolName": "VRTX",
    "trackName": "Field of Grass",
    "trackNameVersion": "Field of Grass",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 3,
    "duration": 264.86,
    "filename": "/clips/compass01.mp3",
    "trackVersion": "1",
    "gdrive": "https://drive.google.com/uc?id=1-HTV3bxoWHLmvxnd_uf-CFx0Z9gya3PZ",
    "order": 24,
    "group": "C",
    "id": 57,
    "intensity": 3,
    "instrumentation": [Instrument.AcousticGuitar],
    "rootMode": Mode.Octatonic,
    "rootTone": "C",
    "lyrics": "",
    "poolName": "CMPS",
    "trackName": "A Compass",
    "trackNameVersion": "Amass Cop",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 4,
    "duration": 244.61,
    "filename": "/clips/compass02.mp3",
    "trackVersion": "2",
    "gdrive": "https://drive.google.com/uc?id=15UQzxlHUvojPf7sFbNkBHlYhrFR2Xm1E",
    "order": 43,
    "group": "D",
    "id": 58,
    "intensity": 5,
    "instrumentation": [Instrument.AcousticGuitar, Instrument.Tambourine, Instrument.Metronome],
    "rootMode": Mode.Octatonic,
    "rootTone": "C",
    "lyrics": "",
    "poolName": "CMPS",
    "trackName": "A Compass",
    "trackNameVersion": "Scam Soap",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 1,
    "duration": 114.55,
    "filename": "/clips/compass03inst.mp3",
    "trackVersion": "3",
    "gdrive": "https://drive.google.com/uc?id=16MSgK_EfW4qkjzFbHyh-YcR-T8ni00z8",
    "order": 3,
    "group": "B",
    "id": 59,
    "intensity": 1,
    "instrumentation": [Instrument.AcousticGuitar],
    "rootMode": Mode.Major,
    "rootTone": "C",
    "lyrics": "",
    "poolName": "CMPS",
    "trackName": "A Compass",
    "trackNameVersion": "Coma Spas",
    "vocal": VocalStyle.Instrumental
  },
  {
    "density": 2,
    "duration": 262.73,
    "filename": "/clips/compass05.mp3",
    "trackVersion": "5",
    "gdrive": "https://drive.google.com/uc?id=1hU8SgKqhRZ6hIjrEGJPME4ytKBD2uiIX",
    "order": 5,
    "group": "B",
    "id": 61,
    "intensity": 2,
    "instrumentation": [Instrument.AcousticGuitar, Instrument.Metronome],
    "rootMode": Mode.Octatonic,
    "rootTone": "C#",
    "lyrics": "",
    "poolName": "CMPS",
    "trackName": "A Compass",
    "trackNameVersion": "Capo Mass",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 3,
    "duration": 166.39,
    "filename": "/clips/compass06.mp3",
    "trackVersion": "6",
    "gdrive": "https://drive.google.com/uc?id=14g1buyXX9PQX1LrTUSxXye1mg7LsAlIM",
    "order": 44,
    "group": "D",
    "id": 62,
    "intensity": 4,
    "instrumentation": [Instrument.AcousticGuitar, Instrument.Metronome],
    "rootMode": Mode.Octatonic,
    "rootTone": "C",
    "lyrics": "",
    "poolName": "CMPS",
    "trackName": "A Compass",
    "trackNameVersion": "A Moss Cap",
    "vocal": VocalStyle.Growl
  },
  {
    "density": 2,
    "duration": 301.82,
    "filename": "/clips/compass07inst.mp3",
    "trackVersion": "7",
    "gdrive": "https://drive.google.com/uc?id=1CloMLhZ4Uzw1IiFZ1TMCc0mHxRy6lhSf",
    "order": 25,
    "group": "C",
    "id": 63,
    "intensity": 3,
    "instrumentation": [Instrument.AcousticGuitar],
    "rootMode": Mode.Octatonic,
    "rootTone": "C",
    "lyrics": "",
    "poolName": "CMPS",
    "trackName": "A Compass",
    "trackNameVersion": "Ass Cam Op",
    "vocal": VocalStyle.Instrumental
  },
  {
    "density": 1,
    "duration": 168.26,
    "filename": "/clips/compass08.mp3",
    "trackVersion": "8",
    "gdrive": "https://drive.google.com/uc?id=1Gq0N3fyX_1edEX-PrQISu41JIjMF8db-",
    "order": 26,
    "group": "C",
    "id": 64,
    "intensity": 3,
    "instrumentation": [Instrument.AcousticGuitar],
    "rootMode": Mode.Octatonic,
    "rootTone": "Bb",
    "lyrics": "",
    "poolName": "CMPS",
    "trackName": "A Compass",
    "trackNameVersion": "Om as Caps",
    "vocal": VocalStyle.Whisper
  },
  {
    "density": 3,
    "duration": 109.7,
    "filename": "/clips/compass09inst.mp3",
    "trackVersion": "9",
    "gdrive": "https://drive.google.com/uc?id=18aPzOnTxW_jW_u7KqpImhWn8f10yJI_k",
    "order": 6,
    "group": "B",
    "id": 65,
    "intensity": 1,
    "instrumentation": [Instrument.AcousticGuitar],
    "rootMode": Mode.Major,
    "rootTone": "C#",
    "lyrics": "",
    "poolName": "CMPS",
    "trackName": "A Compass",
    "trackNameVersion": "Amp Assoc",
    "vocal": VocalStyle.Instrumental
  },
  {
    "density": 2,
    "duration": 141.55,
    "filename": "/clips/compass10inst.mp3",
    "trackVersion": "10",
    "gdrive": "https://drive.google.com/uc?id=1eb7FsJILgsbcrMhiKOAUKJOTMpIQ-GZN",
    "order": 7,
    "group": "B",
    "id": 66,
    "intensity": 1,
    "instrumentation": [Instrument.AcousticGuitar],
    "rootMode": Mode.Major,
    "rootTone": "C#",
    "lyrics": "",
    "poolName": "CMPS",
    "trackName": "A Compass",
    "trackNameVersion": "APO Scams",
    "vocal": VocalStyle.Instrumental
  },
  {
    "density": 2,
    "duration": 182.86,
    "filename": "/clips/compass11inst.mp3",
    "trackVersion": "11",
    "gdrive": "https://drive.google.com/uc?id=1G5cn7wBh-L8PRuX-yvXOoXp9BpVttFKd",
    "order": 8,
    "group": "B",
    "id": 67,
    "intensity": 1,
    "instrumentation": [Instrument.AcousticGuitar],
    "rootMode": Mode.Major,
    "rootTone": "C",
    "lyrics": "",
    "poolName": "CMPS",
    "trackName": "A Compass",
    "trackNameVersion": "Camp Sosa",
    "vocal": VocalStyle.Instrumental
  },
  {
    "density": 3,
    "duration": 183.84,
    "filename": "/clips/compass12.mp3",
    "trackVersion": "12",
    "gdrive": "https://drive.google.com/uc?id=1GSsf0hnNaih372hE-5M0lg631-KVmnNW",
    "order": 45,
    "group": "D",
    "id": 68,
    "intensity": 4,
    "instrumentation": [Instrument.AcousticGuitar, Instrument.Metronome],
    "rootMode": Mode.Octatonic,
    "rootTone": "D",
    "lyrics": "",
    "poolName": "CMPS",
    "trackName": "A Compass",
    "trackNameVersion": "Sao Scamp",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 2,
    "duration": 147.48,
    "filename": "/clips/compass13.mp3",
    "trackVersion": "13",
    "gdrive": "https://drive.google.com/uc?id=1uX8OqM3hRKuvhhwCmJcVj_uoVb8_4WMo",
    "order": 27,
    "group": "C",
    "id": 69,
    "intensity": 2,
    "instrumentation": [Instrument.AcousticGuitar],
    "rootMode": Mode.Octatonic,
    "rootTone": "C",
    "lyrics": "",
    "poolName": "CMPS",
    "trackName": "A Compass",
    "trackNameVersion": "Samosa PC",
    "vocal": VocalStyle.Effects
  },
  {
    "density": 2,
    "duration": 192.12,
    "filename": "/clips/compass14inst.mp3",
    "trackVersion": "14",
    "gdrive": "https://drive.google.com/uc?id=1SjyTnZzYvzB63G15ybPcV1M7pBd43709",
    "order": 28,
    "group": "C",
    "id": 70,
    "intensity": 4,
    "instrumentation": [Instrument.AcousticGuitar],
    "rootMode": Mode.Octatonic,
    "rootTone": "D",
    "lyrics": "",
    "poolName": "CMPS",
    "trackName": "A Compass",
    "trackNameVersion": "Cosa Maps",
    "vocal": VocalStyle.Instrumental
  }
]
